import {
  FighterFrequency,
  UserSeasonFighter,
  UserTotalPoints,
} from '../../domain/models/userSeason.model';
import { AppState } from '../app.state';
import { UserSeasonState } from './userSeason.state';
import { UserSeasonStatsState } from './userSeasonStats.state';

export const getUserSeasonState = (state: AppState): UserSeasonState =>
  state.userSeason;

export const getUserSeasonId = (state: AppState): string | null =>
  state.userSeason.seasonId;

export const getUserSeasonFighters = (
  state: AppState,
): UserSeasonFighter[] | null => state.userSeason.fighters;

export const getUserSeasonLoading = (state: AppState): boolean =>
  state.userSeason.isLoading;

export const getUserSeasonError = (state: AppState): string | null =>
  state.userSeason.error;

export const getUserSeasonLastUpdated = (state: AppState): number | null =>
  state.userSeason.lastUpdated;

export const getUserSeasonStats = (state: AppState): UserSeasonStatsState =>
  state.userSeasonStats;

export const getUserSeasonFighterFrequencySeasonId = (
  state: AppState,
): string | null => state.userSeasonStats.fighterFrequencySeasonId;

export const getUserSeasonUsersTotalPointsSeasonId = (
  state: AppState,
): string | null => state.userSeasonStats.usersTotalPointsSeasonId;

export const getUserSeasonFighterFrequency = (
  state: AppState,
): FighterFrequency[] | null => state.userSeasonStats.fighterFrequency;

export const getUserSeasonUsersTotalPoints = (
  state: AppState,
): UserTotalPoints[] | null => state.userSeasonStats.usersTotalPoints;

export const getUserSeasonStatsLoading = (state: AppState): boolean =>
  state.userSeasonStats.isLoading;

export const getUserSeasonStatsError = (state: AppState): string | null =>
  state.userSeasonStats.error;
